import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LightGallery from 'lightgallery/react';
import 'lightgallery/scss/lightgallery.scss';
import 'lightgallery/scss/lg-zoom.scss';
import lgZoom from 'lightgallery/plugins/zoom';
import axiosInstance, { API_ENDPOINTS, ASSETS_API, HOST_API } from '../axios/axiosInstance';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import SEO from './SEO';

const Galeria = () => {
  const { t } = useTranslation();
  const [galeryImages, SetGaleryImages] = useState([]);

  const fetchData = async () => {
    try {
      const res = await axiosInstance.get(HOST_API + API_ENDPOINTS.galery);
      SetGaleryImages(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <SEO
        titleKey="seo.galleryTitle"
        descriptionKey="seo.galleryDescription"
        path="/gallery"
      />
      <section className="banner dark">
        <div id="menu-parallax">
          <div
            className="bcg background41"
            data-center="background-position: 50% 0px;"
            data-bottom-top="background-position: 50% 100px;"
            data-top-bottom="background-position: 50% -100px;"
            data-anchor-target="#menu-parallax"
          >
            <div className="bg-transparent">
              <div className="banner-content">
                <div className="container">
                  <div className="slider-content" style={{ paddingTop: '160.5px' }}>
                    <h1>{t('gallery.title')}</h1>
                    <p>{t('gallery.subtitle')}</p>
                    <ol className="breadcrumb">
                      <li><Link to='/'>{t('nav.home')}</Link></li>
                      <li>{t('gallery.breadcrumb')}</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="galeria" className="ptb20">
        <LightGallery
          addClass="gallery-container"
          speed={500}
          plugins={[lgZoom]}
          className="d-flex align-items-center justify-content-center"
        >
          {galeryImages != null &&
            galeryImages.length > 0 &&
            galeryImages
              .sort((a, b) => a.order - b.order)
              .map((sliderImage, sldierImageIndex) => (
                <a key={sldierImageIndex} href={`${ASSETS_API}${sliderImage.photo}`}>
                  <LazyLoadImage
                    alt={`Galeria Fleur de Sel Luxembourg - Foto ${sldierImageIndex + 1}`}
                    className="img-responsive"
                    src={`${ASSETS_API}${sliderImage.photo}`}
                    effect="blur" // Adiciona um efeito de blur enquanto a imagem carrega
                    placeholderSrc="url_para_placeholder.jpg" // Substitua pelo caminho do seu placeholder
                  />
                </a>
              ))}
        </LightGallery>
      </section>
    </>
  );
};

export default Galeria;
